import React from "react";
import {
  ShoppingCart,
  ShoppingBag,
  X,
  Minus,
  Plus,
  Trash2,
  ChevronRight
} from "lucide-react";

import "./CartModal.css";

export default function CartModal({
  cart = [],
  setCart,
  onClose,
  onCheckout
}) {

  const totalAmount = cart.reduce((sum, item) => {

    if (item.productType === "SALE") {

      return (
        sum +
        (Number(item.price ?? item.variantPrice ?? 0)) *
        (Number(item.quantity) || 1)
      );

    }

    return (
      sum +
      (Number(item.dailyPrice) || 0) *
      (Number(item.quantity) || 1) *
      (Number(item.days) || 1)
    );

  }, 0);

  const vendorGroups = Object.values(
  cart.reduce((groups, item) => {
    const key = item.vendorId || "unknown";

    if (!groups[key]) {
      groups[key] = {
        vendorId: key,
        vendorName: item.vendorName || "Unknown Vendor",
        items: [],
        total: 0,
      };
    }

    groups[key].items.push(item);

    const itemTotal =
      item.productType === "SALE"
        ? (Number(item.price ?? item.variantPrice ?? 0) *
            (Number(item.quantity) || 1))
        : (Number(item.dailyPrice || 0) *
            (Number(item.quantity) || 1) *
            (Number(item.days) || 1));

    groups[key].total += itemTotal;

    return groups;
  }, {})
);

  return (
    <>

      {/* Backdrop */}

      <div
        className="cart-backdrop"
        onClick={onClose}
      />

      {/* Drawer */}

      <div
        className="cart-sheet"
        onClick={(e) => e.stopPropagation()}
      >

        {/* Handle */}

        <div className="cart-handle" />

        {/* Header */}

        <div className="cart-header">

          <div>

            <h2>

              <ShoppingCart size={24} />

              My Cart

            </h2>

            <p>

              {cart.length} Product
              {cart.length !== 1 ? "s" : ""} Added

            </p>

          </div>

          <button
            className="cart-close"
            onClick={onClose}
          >

            <X size={22} />

          </button>

        </div>

        {/* Body */}

        <div className="cart-body">

          {cart.length === 0 ? (

            <div className="cart-empty">

              <ShoppingBag size={70} />

              <h3>Your Cart is Empty</h3>

              <p>

                Browse construction materials
                and add products to your cart.

              </p>

              <button
                className="cart-shop-btn"
                onClick={onClose}
              >

                Continue Shopping

              </button>

            </div>

          ) : (

            <>
              {vendorGroups.map((group) => (

  <div
    key={group.vendorId}
    className="cart-vendor-group"
  >

    <div className="cart-vendor-header">
      <div>
        <h3>{group.vendorName}</h3>
        <p>{group.items.length} Product{group.items.length !== 1 ? "s" : ""}</p>
      </div>
    </div>

    {group.items.map((item) => (


                <div
                  key={item.cartItemId}
                  className="cart-product-card"
                >

                  {/* LEFT */}

                  <div className="cart-product-left">

                    {/* Product Image */}

                    <div className="cart-product-image">

                      {item.imageUrl || item.image ? (

                        <img
                          src={item.imageUrl || item.image}
                          alt={item.name}
                        />

                      ) : (

                        <ShoppingBag size={34} />

                      )}

                    </div>

                    {/* Product Details */}

                    <div className="cart-product-info">

                      <h4>

                        {item.name}

                      </h4>

                      {item.vendorName && (

                        <div className="cart-vendor">

                          ✔ Civilink Verified

                          <span>

                            {item.vendorName}

                          </span>

                        </div>

                      )}

                      <div className="cart-code">

                        {item.vendorProductCode}

                      </div>

                      <div className="cart-price">

                        {item.productType === "SALE"
                          ? `₹${item.price ?? item.variantPrice}`
                          : `₹${item.dailyPrice}/day`}

                        {item.size &&
                          ` • ${item.size}`}

                      </div>

                    </div>

                  </div>

                  {/* RIGHT */}

                  <div className="cart-product-right">

                    {/* Quantity */}

                    <div className="cart-counter">
<button
  onClick={() =>
    setCart(prev =>
      prev
        .map(p =>
          p.cartItemId === item.cartItemId
            ? {
                ...p,
                quantity: Math.max(1, p.quantity - 1)
              }
            : p
        )
    )
  }
>
  <Minus size={16} />
</button>

<input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  value={item.quantity}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");

    setCart(prev =>
      prev.map(p =>
        p.cartItemId === item.cartItemId
          ? {
              ...p,
              quantity: value === "" ? "" : Math.max(1, Number(value))
            }
          : p
      )
    );
  }}
  onBlur={() => {
    setCart(prev =>
      prev.map(p =>
        p.cartItemId === item.cartItemId &&
        (p.quantity === "" || p.quantity < 1)
          ? {
              ...p,
              quantity: 1
            }
          : p
      )
    );
  }}
/>

<button
  onClick={() =>
    setCart(prev =>
      prev.map(p =>
        p.cartItemId === item.cartItemId
          ? {
              ...p,
              quantity: Number(p.quantity || 1) + 1
            }
          : p
      )
    )
  }
>
  <Plus size={16} />
</button>
  

</div>

                    {/* Rental */}

                    {item.productType === "RENTAL" && (

                      <div className="cart-days">

                        <small>

                          Rental Days

                        </small>

                        <div className="cart-counter">

                          <button
  onClick={() =>
    setCart(prev =>
      prev.map(p =>
        p.cartItemId === item.cartItemId
          ? {
              ...p,
              days: Math.max(1, Number(p.days || 1) - 1)
            }
          : p
      )
    )
  }
>
  <Minus size={16} />
</button>

                          <input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  value={item.days || 1}
  onChange={(e) => {

    const value = e.target.value.replace(/\D/g, "");

    setCart(prev =>
      prev.map(p =>
        p.cartItemId === item.cartItemId
          ? {
              ...p,
              days: value === "" ? "" : Math.max(1, Number(value))
            }
          : p
      )
    );

  }}
  onBlur={() => {

    setCart(prev =>
      prev.map(p =>
        p.cartItemId === item.cartItemId &&
        (!p.days || p.days < 1)
          ? {
              ...p,
              days: 1
            }
          : p
      )
    );

  }}
/>

                          <button
  onClick={() =>
    setCart(prev =>
      prev.map(p =>
        p.cartItemId === item.cartItemId
          ? {
              ...p,
              days: Number(p.days || 1) + 1
            }
          : p
      )
    )
  }
>
  <Plus size={16} />
</button>
                        </div>

                      </div>

                    )}

                    {/* Total */}

                    <div className="cart-item-total">

                      ₹

                      {item.productType === "SALE"
                        ? (
                            Number(
                              item.price ??
                                item.variantPrice
                            ) *
                            Number(item.quantity)
                          ).toLocaleString()
                        : (
                            Number(item.dailyPrice) *
                            Number(item.quantity) *
                            Number(item.days || 1)
                          ).toLocaleString()}

                    </div>

                    {/* Remove */}

                    <button
                      className="cart-remove"
                      onClick={() =>
                        setCart((prev) =>
                          prev.filter(
    p => p.cartItemId !== item.cartItemId
)
                        )
                      }
                    >

                      <Trash2 size={18} />

                      Remove

                    </button>

                  </div>

                </div>

              ))}

             

<div className="cart-vendor-footer">

  <div className="cart-vendor-total">

    <div className="cart-total-label">
      Vendor Total
    </div>

    <div className="cart-total-value">
      ₹{group.total.toLocaleString()}
    </div>

  </div>

  <button
    className="cart-checkout-btn"
    onClick={() => onCheckout(group.items)}
  >
    Proceed to Checkout
  </button>

</div>

 </div>

))}

              {/* Continue Shopping */}

              <button
                className="cart-add-more"
                onClick={onClose}
              >

                <ShoppingBag size={18} />

                Continue Shopping

                <ChevronRight size={18} />

              </button>
              {/* Bottom spacing for sticky footer */}

              <div style={{ height: 100 }} />

            </>

          )}

        </div>

        {/* ==========================
             STICKY FOOTER
        =========================== */}

        
        

      </div>

    </>

  );

}